import NumberInput from '@standardsdigital/ui-components/NumberInput';
import { useTranslation } from 'react-i18next';
import type { UseFormRegister } from 'react-hook-form';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';
import {
  priceFactorDecimalCount,
  priceFactorMaxLength,
  type ServiceLevelFormValues,
} from '../../../serviceLevelOptions';
import { messageSeverity } from './formInputHelpers';

interface PriceFactorInputProps {
  register: UseFormRegister<ServiceLevelFormValues>;
  error?: string;
  isDirty: boolean;
  disabled: boolean;
}

function PriceFactorInput({
  register,
  error,
  isDirty,
  disabled,
}: Readonly<PriceFactorInputProps>) {
  const { t } = useTranslation();

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <NumberInput
        {...register('priceFactor')}
        inputMode="decimal"
        maxLength={priceFactorMaxLength}
        step={10 ** -priceFactorDecimalCount}
        label={t('serviceLevels.form.priceFactor')}
        message={error}
        severity={messageSeverity(error)}
        disabled={disabled}
        required
      />
    </FieldStatusWrapper>
  );
}

export default PriceFactorInput;
